import { getWidgetConfig } from '../runtime/widgetConfig'

export function resolvePrintboxFamilyId(category: any): number | null {
  const cfg = category?.editorConfig ?? null
  const pbx = cfg?.printbox ?? cfg?.printBox ?? null
  const enabled = pbx?.enabled ?? pbx?.isEnabled ?? cfg?.isPrintboxCategory ?? false
  const familyId = Number(pbx?.familyId ?? pbx?.id ?? cfg?.printboxFamilyId ?? 0)
  return enabled && familyId > 0 ? familyId : null
}

export function buildPrintboxEditorUrl(familyId: number): string {
  const cfg = getWidgetConfig()
  const editorBase = String(cfg?.editorBaseUrl || '').trim().replace(/\/+$/, '')
  const baseRoot = editorBase ? editorBase.replace(/\/editor$/i, '') : window.location.origin
  return `${baseRoot}/printbox/editor/${familyId}`
}
